import { useEffect } from 'react';
import type Player from 'video.js/dist/types/player';
import type { FeedEntry } from '~/services/layout/index.ts';
import { disposePlayerAndNavigate, playerGoBack } from '../utils';

export function useRedirectOnVideoEnd({
  player,
  playableItem,
  baseURL,
  isPlayNext,
  isContinueWatchingSyncedFeed,
  isInlineModeEnabled,
}: {
  player: Player | null;
  playableItem: FeedEntry;
  baseURL: string;
  isPlayNext: boolean;
  isContinueWatchingSyncedFeed: boolean;
  isInlineModeEnabled: boolean;
}) {
  useEffect(() => {
    if (!player || isPlayNext || isInlineModeEnabled) return;

    const handleRedirectOnVideoEnd = () => {
      disposePlayerAndNavigate({
        player,
        isContinueWatchingSyncedFeed,
        navigationFunction: () => {
          playerGoBack({
            baseURL,
            playableItem,
          });
        },
      });
    };

    player.on('ended', handleRedirectOnVideoEnd);

    return () => {
      player.off('ended', handleRedirectOnVideoEnd);
    };
  }, [
    player,
    isPlayNext,
    isInlineModeEnabled,
    playableItem,
    baseURL,
    isContinueWatchingSyncedFeed,
  ]);
}
